import { useState } from "react";
import * as C from "./styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const Input = ({ type, placeholder, value, onChange }) => {
  const [showPassword, setShowPassword] = useState(false);

  const isPassword = type === "password";

  return (
    <C.InputContainer>
      <C.InputField
        type={isPassword && showPassword ? "text" : type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />

      {isPassword && (
        <C.IconButton
          type="button"
          onClick={() => setShowPassword((prev) => !prev)}
        >
          {showPassword ? <VisibilityOff /> : <Visibility />}
        </C.IconButton>
      )}
    </C.InputContainer>
  );
};

export default Input;
